<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-bind="buttonProps"
          v-if="
            flux.state === 'processing'
            || flux.state === 'pending'
          "
          v-on="on"
          icon
          color="red"
          @click.stop="openDialog()"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </template>

      <span>Cancel {{ flux.name }} feed processing</span>
    </v-tooltip>

    <v-dialog
      v-model="confirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline"
        >Confirmation</v-card-title>

        <v-card-text>
          <p>You are about to cancel the processing of the following feed:</p>
          <p class="text-center">
            <strong class="title">{{ flux.name }}</strong>
          </p>
          <p>Are you sure you want to cancel it?</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            text
            @click="closeDialog()"
          >No, keep processing</v-btn>

          <v-btn
            color="primary"
            @click="confirmCancellation()"
            depressed
          >Yes, cancel it</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'CancelFluxButton',
  data() {
    return {
      confirmDialog: false
    }
  },
  props: {
    buttonProps: {
      type: Object,
      default() {
        return {
          text: true,
          small: true
        }
      }
    },
    flux: Object
  },
  methods: {
    openDialog() {
      this.confirmDialog = true
    },
    closeDialog() {
      this.confirmDialog = false
    },
    async confirmCancellation() {
      try {
        const { data: { data: flux } } = await this.$axios.patch(`/flux/${this.flux.id}/cancel`)
        this.flux.state = flux.state
        this.flux.errors = flux.errors
        this.closeDialog()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
